import { gql } from '@apollo/client';

export const UPSERT_INSIGHT = gql`
  mutation upsertInsight($input: UpsertInsightInput!) {
    insight: upsertInsight(input: $input) {
      id
    }
  }
`;
